export const uploadModalFields = {
    full: {
        title: 'Keywords imported successfully',
        subTitle: 'We have successfully imported the uploaded file.',
    },
    partial: {
        title: 'keywords imported partially',
        subTitle: 'We have partially imported the uploaded file.',
    },
    error: {
        title: 'Import failed',
        subTitle: 'We have failed to import the uploaded file.',
    },
};
